import { ShieldAlert } from "lucide-react";

/** Aviso fixo mostrado quando um agente entrou no portal "como" este cliente (via
 * "Acessar como este cliente" na tela de Clientes) — pra nunca ser confundido com uma
 * sessão real do cliente. */
export function ImpersonationBanner() {
  const handleExit = () => {
    // Só limpa a sessão do CLIENTE — o auth_token do agente nunca foi tocado, então ele
    // continua logado ao voltar pro admin.
    localStorage.removeItem("client_token");
    localStorage.removeItem("client_user");
    localStorage.removeItem("client_impersonated");
    window.location.href = "/clients";
  };

  return (
    <div className="flex flex-wrap items-center justify-center gap-2 bg-destructive px-4 py-2 text-center text-sm font-medium text-destructive-foreground">
      <ShieldAlert className="h-4 w-4 shrink-0" />
      <span>Você está vendo o portal como este cliente (modo admin). O envio de mensagens está desativado.</span>
      <button
        type="button"
        onClick={handleExit}
        className="ml-2 shrink-0 rounded border border-destructive-foreground/40 px-2 py-0.5 text-xs font-semibold underline underline-offset-2 hover:bg-destructive-foreground/10"
      >
        Voltar para o admin
      </button>
    </div>
  );
}
